// extracted by mini-css-extract-plugin
module.exports = {"header-nav":"HeaderNav_header-nav__3IX2c","icon":"HeaderNav_icon__3tXm6"};